import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import { Switch, Route, useHistory, useLocation } from 'react-router';
import Header from '../../components/Header';
import { Drawer, List, ListItemIcon, ListItem, Divider, ListItemText, Toolbar, Theme, createStyles, makeStyles } from '@material-ui/core';
import HomeIcon from '@material-ui/icons/Home'

import NoteIcon from '@material-ui/icons/Note';


import CoachHome from '../../page/coach/Home'
import ClientHome from '../../page/coach/ClientHome';
import ClientCoaching from '../../page/coach/ClientCoaching'
import CoachingNotes from '../../page/coach/CoachingNotes';
import ClientDetails from '../../page/coach/ClientDetails';
import CoachingHistory from './CoachingHistory';

const coachRouter = [
  {
    name: '首页',
    path: ['/coach/home', '/coach/home/:type'],
    icon: <HomeIcon />,
    component: <CoachHome />
  },
  {
    name: '教练笔记',
    path: '/coach/notes',
    icon: <NoteIcon />,
    component: <CoachingNotes />
  }
]

const drawerWidth = 240;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
      whiteSpace: 'nowrap',
    },
    drawerPaper: {
      width: drawerWidth,
    },
    drawerContainer: {
      overflow: 'auto',
    },
    drawerOpen: {
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    drawerClose: {
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      overflowX: 'hidden',
      width: theme.spacing(5) + 1,
      [theme.breakpoints.up('sm')]: {
        width: theme.spacing(7) + 1,
      },
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),

    }
  }),
);

function App() {
  const classes = useStyles()
  const history = useHistory()
  const location = useLocation()
  const [showDrawer, setShowDrawer] = useState(true)
  const [openDrawer, setOpenDrawer] = useState(false)

  const [userType] = useState(() => localStorage.getItem('user'))
  useEffect(() => {
    if (userType !== 'coach') {
      history.replace(`/${userType}/home`)
    }
  }, [userType])

  const handleDrawerClick = (path: string | string[]) => () => {
    let to = path
    if (typeof path === 'object') {
      to = path[0]
    }
    history.replace(to + '?refresh=' + new Date().getTime())
  }

  const handleDrawerToggle = () => {
    setOpenDrawer(!openDrawer);
  };

  useEffect(() => {
    if (location.pathname === '/admin/signin') {
      setShowDrawer(false)
    } else {
      setShowDrawer(true)
    }
  }, [location])

  return (
    <div className={classes.root}>
      <Header title="教练后台" showMenu={showDrawer} onMenuClick={handleDrawerToggle} position="fixed" className={classes.appBar} />
      {showDrawer && <Drawer
        variant="permanent"
        open={openDrawer}
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: openDrawer,
          [classes.drawerClose]: !openDrawer,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: openDrawer,
            [classes.drawerClose]: !openDrawer,
          }),
        }}>
        <Toolbar />
        <div className={classes.drawerContainer}>
          <List>
            {coachRouter.map((route, index) => (
              <ListItem selected={route.path === location.pathname} onClick={handleDrawerClick(route.path)} button key={route.path.toString()}>
                <ListItemIcon>{route.icon}</ListItemIcon>
                <ListItemText primary={route.name} />
              </ListItem>
            ))}
          </List>
          <Divider />
        </div>
      </Drawer>}

      <main className={classes.content}>
        <Toolbar />
        <Switch>

          {coachRouter.map((route, index) => (
            <Route path={route.path} key={route.name.toString()} exact>
              {route.component}
            </Route>
          ))}
          <Route path="/coach/client/:clientId/initialinterview/:id" exact>
            <ClientHome />
          </Route>
          
          <Route path="/coach/client/:clientId/coaching/:id" exact>
            <ClientCoaching />
          </Route>
          <Route path="/coach/client/:clientId/coaching/:id/history" exact>
            <CoachingHistory />
          </Route>
          <Route path="/coach/client/:clientId" exactt>
            <ClientDetails />
          </Route>
        </Switch>
      </main>
    </div>
  );
}

export default App;
